<template>
  <v-sheet class="fill-height" tile color="#ffffff">
    <v-sheet tile color="primary" align="center" class="top-sheet" dark>
      <v-container fluid>
        <br />
        <br />
        <div class="search-field">
          <GmapMap
            v-show="false"
            :options="{
              streetViewControl: false,
              mapTypeControl: false,
              zoomControl: false,
              gestureHandling: 'cooperative'
            }"
            @idle="sync"
            @center_changed="updateCenter"
            :center="map_center"
            :zoom="zoom"
            map-type-id="terrain"
          >
            <GmapMarker
              :clickable="false"
              :draggable="false"
              :position="center"
            />
          </GmapMap>
          <v-text-field
            hide-details
            light
            color="white"
            solo
            v-model="address"
            autocomplete="new-password"
            label="Find Spot"
            class="spot_finder"
            name="location"
            clearable
            dense
            filled
            dark
            flat
            background-color="#4688D3"
            clear-icon="clear"
            autofocus
            placeholder="Search"
            ref="text_input"
            @select="reInt()"
            required
            @input="resetLatLng"
          >
            <template slot="prepend-inner">
              <v-icon>search</v-icon>
            </template>
            <template slot="append">
              <v-icon @click="locate" color="white">gps_fixed</v-icon>
            </template>
          </v-text-field>
          <FullscreenModalWithSlot
            :dense="false"
            @opened="toggleOverlay"
            @closed="toggleOverlay"
          >
            <template v-slot:activator>
              <div @click="showMapModal" class="map-btn">
                <v-btn small text>
                  <img src="/static/map_icon.svg" />
                  <div>Map</div>
                </v-btn>
              </div>
            </template>
            <template v-slot:toolbar_left>
              <v-btn icon color="white" @click="closeMap">
                <v-icon>keyboard_backspace</v-icon>
              </v-btn>
            </template>
            <template v-slot:toolbar_right> </template>
            <template v-slot:title>
              Select your location
            </template>
            <template v-slot:content>
              <div class="map">
                <GmapMap
                  :options="{
                    streetViewControl: false,
                    mapTypeControl: true,
                    zoomControl: true,
                    gestureHandling: 'cooperative'
                  }"
                  @idle="sync"
                  @center_changed="updateCenter"
                  :center="map_center"
                  :zoom="zoom"
                  map-type-id="terrain"
                >
                  <GmapMarker
                    :clickable="false"
                    :draggable="false"
                    :position="center"
                  />
                </GmapMap>
              </div>
            </template>
          </FullscreenModalWithSlot>
        </div>
      </v-container>
      <v-overlay v-model="overlay"></v-overlay>
    </v-sheet>
    <v-container fluid align="center" class="search-content">
      <v-spacer style="height: 128px"></v-spacer>
      <v-row>
        <template v-if="this.lat == undefined && this.lng == undefined">
          <v-col class="found" cols="12" align="center">
            <div class="no-data">
              <div>
                <v-img
                  width="156"
                  class="mb-6"
                  src="/static/no_data_search.svg"
                />
                <span>
                  Please enter valid address to search for stores or use map to
                  define the location
                </span>
              </div>
            </div>
          </v-col>
        </template>
        <template v-else-if="storesInRadius > 0">
          <v-col class="found" cols="12">
            {{ storesInRadius }}
            {{ storesInRadius == 1 ? "store" : "stores" }} found within a 50
            mile radius
          </v-col>
          <v-col
            v-for="item in sortedFiltered['initial']"
            cols="12"
            lg="4"
            xs="12"
            sm="6"
            md="6"
            :key="item.store.id"
          >
            <StoreTile
              mode="visit"
              :store="item.store"
              :distance="Math.round(item.distance * 10) / 10"
            ></StoreTile>
          </v-col>
          <v-col
            v-for="item in sortedFiltered['lazy']"
            cols="12"
            lg="4"
            xs="12"
            sm="6"
            md="6"
            :key="item.store.id"
          >
            <v-lazy
              v-model="item.isActive"
              :options="{ threshold: 0.5 }"
              transition="slide-y-transition"
            >
              <v-sheet
                min-height="272px"
                class="fill-height"
                color="transparent"
              >
                <StoreTile
                  mode="visit"
                  :store="item.store"
                  :distance="Math.round(item.distance * 10) / 10"
                ></StoreTile>
              </v-sheet>
            </v-lazy>
          </v-col>
        </template>
        <template v-else align="center">
          <v-col class="found" cols="12">
            No stores in 50 mile radius, here are the stores closest to you:
          </v-col>

          <v-col
            v-for="item in sortedStores['initial']"
            cols="12"
            lg="4"
            xs="12"
            sm="6"
            md="6"
            :key="item.store.id"
          >
            <StoreTile
              mode="visit"
              :store="item.store"
              :distance="Math.round(item.distance * 10) / 10"
            ></StoreTile>
          </v-col>

          <v-col
            v-for="item in sortedStores['lazy']"
            cols="12"
            lg="4"
            xs="12"
            sm="6"
            md="6"
            :key="item.store.id"
          >
            <v-lazy
              v-model="item.isActive"
              :options="{ threshold: 0.5 }"
              transition="slide-y-transition"
            >
              <v-sheet
                min-height="272px"
                class="fill-height"
                color="transparent"
              >
                <StoreTile
                  mode="visit"
                  :store="item.store"
                  :distance="Math.round(item.distance * 10) / 10"
                ></StoreTile>
              </v-sheet>
            </v-lazy>
          </v-col>
        </template>
      </v-row>
    </v-container>
  </v-sheet>
</template>

<script>
import { mapGetters } from "vuex";
import StoreTile from "../Stores/StoreTile";
import { gmapApi } from "vue2-google-maps";
import FullscreenModalWithSlot from "../Elements/FullscreenModalWithSlot";
import { Auth } from "aws-amplify";
import {registerUserForNotification} from "@/utils/utils"

function getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
  var R = 3958.8; // Radius of the earth in km
  var dLat = deg2rad(lat2 - lat1); // deg2rad below
  var dLon = deg2rad(lon2 - lon1);
  var a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(lat1)) *
      Math.cos(deg2rad(lat2)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  var d = R * c; // Distance in km
  return d;
}

function deg2rad(deg) {
  return deg * (Math.PI / 180);
}

export default {
  metaInfo: {
    meta: [
      {
        name: "viewport",
        content:
          "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0"
      }
    ]
  },
  name: "Search",
  components: { FullscreenModalWithSlot, StoreTile },
  data: function() {
    return {
      show_address: false,
      isActive: false,
      overlay: false,
      search_started: false,
      autocomplete: null,
      geocoder: null,
      center: {
        lat: 37,
        lng: -101
      },
      map_center: {
        lat: 37,
        lng: -101
      },
      zoom: 15
    };
  },
  mounted: function() {
    //  this.registerUserForNotification();
    this.$store.dispatch("reloadBrandsStores");
    if (this.google) {
      this.autocomplete = new this.google.maps.places.Autocomplete(
        this.$refs.text_input.$refs.input,
        { componentRestrictions: { country: "US" } }
      );
      this.autocomplete.addListener("place_changed", this.fillInAddress);
      this.geocoder = new this.google.maps.Geocoder();
      this.loadInitialLocation();
    }
    registerUserForNotification();
  },
  beforeDestroy: function() {
    delete this.autocomplete;
    delete this.geocoder;
  },
  watch: {
    google() {
      if (this.google != null) {
        this.autocomplete = new this.google.maps.places.Autocomplete(
          this.$refs.text_input.$refs.input,
          { componentRestrictions: { country: "US" } }
        );
        this.autocomplete.addListener("place_changed", this.fillInAddress);
        this.geocoder = new this.google.maps.Geocoder();
        this.loadInitialLocation();
      }
    },
    autocomplete() {
      if (this.address) {
        this.$nextTick(() => {
          this.fillInAddress();
        });
      }
    }
  },
  methods: {
    toggleOverlay() {
      this.overlay = !this.overlay;
    },
    showMapModal() {
      this.$store.dispatch("showMapModal");
    },
    locate() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(position => {
          this.show_address = true;
          this.center = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          };
          this.map_center = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          };
          var circle = new google.maps.Circle({
            center: this.center,
            radius: position.coords.accuracy
          });
          this.autocomplete.setBounds(circle.getBounds());
          var that = this;

          this.geocoder.geocode(
            { location: this.center },
            (results, status) => {
              if (status == "OK" && results.length > 0) {
                that.address = results[0].formatted_address;
                that.lng = that.center.lng;
                that.lat = that.center.lat;
              } else {
                that.address = "";
              }
              this.$store.dispatch("hideMapModal");
            }
          );
        });
      }
    },
    loadInitialLocation() {
      if (!this.getAddress) {
        this.locate();
      } else {
        this.center.lat = this.getLat;
        this.center.lng = this.getLng;
      }
    },
    sync() {
      if (this.map_center != this.center) {
        this.map_center = this.center;
        var that = this;
        if (this.timer_id) {
          clearTimeout(this.timer_id);
        }
        this.address = "Fetching Address...";
        if (this.show_address) {
          this.timer_id = setTimeout(() => {
            this.geocoder.geocode(
              { location: this.center },
              (results, status) => {
                if (status == "OK" && results.length > 0) {
                  that.address = results[0].formatted_address;
                } else {
                  that.address = "";
                }
              }
            );
          }, 500);
        } else {
          this.address = "";
        }
      }
    },
    resetLatLng() {
      this.lat = undefined;
      this.lng = undefined;
      this.show_address = true;
    },
    closeMap() {
      var that = this;
      this.geocoder.geocode({ location: this.center }, (results, status) => {
        if (status == "OK" && results.length > 0) {
          that.address = results[0].formatted_address;
          that.lng = that.center.lng;
          that.lat = that.center.lat;
        } else {
          that.address = "";
        }
        this.$store.dispatch("hideMapModal");
      });
    },
    updateCenter(latLng) {
      this.center = {
        lat: latLng.lat(),
        lng: latLng.lng()
      };

      this.address = "Fetching Address...";
    },
    reInt() {
      delete this.autocomplete;
      this.autocomplete = new this.google.maps.places.Autocomplete(
        this.$refs.text_input.$refs.input,
        { componentRestrictions: { country: "US" } }
      );
      this.geocoder = new this.google.maps.Geocoder();
      this.autocomplete.addListener("place_changed", this.fillInAddress);
    },
    fillInAddress() {
      var results = this.autocomplete.getPlace();
      if (results && results.formatted_address) {
        this.address = results.formatted_address;
        this.center = {
          lat: results.geometry.location.lat(),
          lng: results.geometry.location.lng()
        };
        this.map_center = this.center;
        this.lat = this.center.lat;
        this.lng = this.center.lng;
        this.zoom = 18;
      }
    },
    // registerUserForNotification() {
    //   Auth.currentSession()
    //     .then(data => {
    //       this.$store.dispatch("setOwnerId", data.idToken.payload.sub);
    //     })
    //     .catch(err => console.log(err));

    //   try {
    //     var ownerId = this.$store.getters.currentOwnerId;
    //    if (ownerId !== "null" && ownerId !== "") {
    //     OneSignal.push(function() {
    //       OneSignal.setExternalUserId(ownerId);
    //     });
    //     }
    //   } catch (error) {}
    // }
  },
  computed: {
    ...mapGetters([
      "loadingState",
      "allStores",
      "getDefaultPage",
      "getAddress",
      "getLng",
      "getLat",
      "getTimezone"
    ]),
    google: gmapApi,
    address: {
      get: function() {
        return this.getAddress;
      },
      set: function(new_val) {
        this.$store.dispatch("setAddress", new_val);
      }
    },
    timezone: {
      get: function() {
        return console.log("TimeZone : ", this.getTimezone);
      }
    },
    lng: {
      get: function() {
        return this.getLng;
      },
      set: function(new_val) {
        this.$store.dispatch("setLng", new_val);
      }
    },
    lat: {
      get: function() {
        return this.getLat;
      },
      set: function(new_val) {
        this.$store.dispatch("setLat", new_val);
      }
    },
    storesInRadius() {
      return [...this.sortedFiltered["initial"], ...this.sortedFiltered["lazy"]]
        .length;
    },
    sortedFiltered() {
      if (this.lat && this.lng) {
        var stores_with_distance = [];

        for (var store of this.allStores) {
          var distance = getDistanceFromLatLonInKm(
            this.lat,
            this.lng,
            store.lat,
            store.lng
          );
          if (distance < 50) {
            stores_with_distance.push({ distance: distance, store: store });
          }
        }
        let filtered = stores_with_distance.sort((a, b) =>
          a.distance > b.distance ? 1 : b.distance > a.distance ? -1 : 0
        );
        let initial = filtered.filter(function(value, index, arr) {
          return index < 9;
        });
        let lazy = filtered.filter(function(value, index, arr) {
          return index >= 9;
        });
        return {
          initial: initial,
          lazy: lazy
        };
      }
      return [];
    },
    sortedStores() {
      var stores_with_distance = [];
      for (var store of this.allStores) {
        var distance = getDistanceFromLatLonInKm(
          this.lat,
          this.lng,
          store.lat,
          store.lng
        );
        stores_with_distance.push({
          distance: distance,
          store: store,
          isActive: false
        });
      }
      let sorted = stores_with_distance.sort((a, b) =>
        a.distance > b.distance ? 1 : b.distance > a.distance ? -1 : 0
      );
      let initial = sorted.filter(function(value, index, arr) {
        return index < 9;
      });
      let lazy = sorted.filter(function(value, index, arr) {
        return index >= 9;
      });
      return {
        initial: initial,
        lazy: lazy
      };
    }
  }
};
</script>
<style lang="scss" scoped>
.top-sheet {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 4;
}

.search-content {
}

.search-field {
  display: grid;
  grid-template-columns: 1fr 52px;
}

.found {
  font-size: 0.85rem;
}

.map {
  z-index: 100;

  .vue-map-container {
    width: 94vw;
    height: calc(94vh - 44px);
  }
}
</style>
<style lang="scss">
.spot_finder {
  .v-input__icon--prepend-inner {
    .v-icon {
      color: rgba(0, 0, 0, 0.54) !important;
    }
  }
}

.map-btn {
  margin-left: 0.5rem;
  font-size: 10px;

  .v-btn {
    text-transform: none !important;
    height: 40px !important;

    .v-btn__content {
      display: grid;
      text-align: -webkit-center;

      img {
        width: 24px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/Pages/Search.vue